module.exports = {
    EC_ENV_LOCAL: 'local',
    EC_ENV_DEV: 'dev',
    EC_ENV_PROD: 'prod',
    EC_LOCAL_DOMAIN: 'easycontent.local',
    EC_DEV_DOMAIN: 'cheesycontent.com',
    EC_PROD_DOMAIN: 'easycontent.io',
    MOBILE_WINDOW_WIDTH: 500
}
